import { gql } from '@apollo/client';

export const SUBSCRIPTION_DETAILS = gql`
  query SubscriptionDetails {
    subscriptionDetails {
      id
      recurringInterval
      status
      currentPeriodEnd
      cancelAtPeriodEnd
      downgradeScheduledTo
      paymentFailed
    }
  }
`;

export const SUBSCRIPTION_STATUS = gql`
  query SubscriptionStatus {
    subscriptionStatus {
      status
      cancelAtPeriodEnd
    }
  }
`;

export const PREVIEW_PRORATION_QUERY = gql`
  query PreviewProration(
    $targetPlan: PlanEnum!
    $targetRecurringInterval: RecurringIntervalEnum!
  ) {
    previewProration(
      targetPlan: $targetPlan
      targetRecurringInterval: $targetRecurringInterval
    ) {
      credit {
        amount
        description
      }
      cost {
        amount
        description
      }
      total {
        amount
      }
      prorationDate
    }
  }
`;

export const SUBSCRIPTION_INVOICES_QUERY = gql`
  query SubscriptionInvoices {
    subscriptionInvoices {
      id
      date
      status
      total
      receiptUrl
      amountPaid
    }
  }
`;

export const FAILED_PAYMENT_DETAILS = gql`
  query FailedPaymentDetails {
    failedPaymentDetails {
      amount
      error
      status
    }
  }
`;
